// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2d9ap","inputDescription":"styles_inputDescription__1ApfD"};